/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/
import TAccordion from './Accordion';
import Item from './Item';
import Header from './Header';
import Body from './Body';

/**
 * UI Toolkit component based on Veneer Accordion
 * @public
 */
const AccordionTemp: any = TAccordion;
AccordionTemp.Item = Item;
AccordionTemp.Header = Header;
AccordionTemp.Body = Body;
AccordionTemp.behavior = AccordionTemp.behavior || 'multiExpand';

const Accordion = AccordionTemp;

export type {
  AccordionProps,
  AccordionHeaderProps,
  AccordionItemsProps
} from './types';
export default Accordion;
